import { App } from '@/console/app';
import { createAppRoot } from '@/shared/utils/create-app-root/create-app-root';

createAppRoot({
  app: <App />,
});
